import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=e2bb922c&scoped=true&"
var script = {}
import style0 from "./Product.vue?vue&type=style&index=0&id=e2bb922c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2bb922c",
  null
  
)

export default component.exports